import { cn } from "@omni/utils/styles";

export const FamiliesSkeleton = () => {
    return (
        <>
            <div className={cn("tw:h-7.5 tw:w-16 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-20 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-14 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-14 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-23 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-20 tw:rounded-sm tw:bg-grey")} />
            <div className={cn("tw:h-7.5 tw:w-15 tw:rounded-sm tw:bg-grey")} />
        </>
    );
};
